import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const CurrencyContext = createContext({
    currency: "PKR",
    setCurrency: () => { },
    rates: {},
});

export const CurrencyProvider = ({ children }) => {
    const [currency, setCurrency] = useState("PKR");
    const [rates, setRates] = useState({});

    useEffect(() => {
        const fetchRates = async () => {
            try {
                const response = await axios.get(
                    "https://api.exchangerate-api.com/v4/latest/PKR"
                );
                setRates(response.data.rates);
            } catch (error) {
                console.error("Error fetching exchange rates:", error);
            }
        };

        fetchRates();
    }, []);

    return (
        <CurrencyContext.Provider value={{ currency, setCurrency, rates }}>
            {children}
        </CurrencyContext.Provider>
    );
};

export const useCurrency = () => useContext(CurrencyContext);
